/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_LinesInputs */

const en_col_lines = /** @type {(inputs: Col_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lines`)
};

/**
* | output |
* | --- |
* | "Lines" |
*
* @param {Col_LinesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const col_lines = /** @type {((inputs?: Col_LinesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_LinesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_col_lines(inputs)
});